import { Badge } from '@fluentui/react-components';
import { CheckmarkCircleRegular, ClockRegular, DismissCircleRegular, WarningRegular } from '@fluentui/react-icons';
import React from 'react';
import { ScrubbingStatusId } from '../../models';

const SCRUBBING_STATE_BADGE: Record<number, { color: 'success' | 'danger' | 'informative' | 'warning'; icon: React.JSX.Element }> = {
  [ScrubbingStatusId.Passed]: { color: 'success', icon: <CheckmarkCircleRegular /> },
  [ScrubbingStatusId.Disqualified]: { color: 'danger', icon: <DismissCircleRegular /> },
  [ScrubbingStatusId.Pending]: { color: 'informative', icon: <ClockRegular /> },
  [ScrubbingStatusId['Pending-Disqualified']]: { color: 'warning', icon: <WarningRegular /> },
};

export const scrubbingStateBadge = (scrubbingStatusId: number, displayName: string): React.JSX.Element => {
  const config = SCRUBBING_STATE_BADGE[scrubbingStatusId];
  if (!config) return <>{displayName}</>;
  return (
    <Badge appearance='tint' color={config.color} icon={config.icon}>
      {displayName}
    </Badge>
  );
};
